import { MdEuro, MdOutlineShoppingBasket } from 'react-icons/md';
import { TbPigMoney, TbMoneybag } from 'react-icons/tb';

import MiniStatistics from 'components/card/MiniStatistics';

const SupplierStats = (props: { id?: string }) => {
    return (
        <div className="col-span-12 grid h-full w-full grid-cols-2 gap-3 sm:gap-5 md:grid-cols-2 xl:grid-cols-4">
            <MiniStatistics
                name="Commandes"
                value={'-'}
                icon={<MdOutlineShoppingBasket color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
            <MiniStatistics
                name="Quantité commandée"
                value={'-'}
                icon={<TbPigMoney color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
            <MiniStatistics
                name="Achats 3 dern. mois"
                value={'- €'}
                icon={<MdEuro color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
            <MiniStatistics
                name="Achats 6 dern. mois"
                value={'- €'}
                icon={<TbMoneybag color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
        </div>
    );
};

export default SupplierStats;
